module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Gd-Hc-Ia.6c4b9171.png";